import createReactClass from 'create-react-class';
import './UserRatingButton.css';
import UserRatingNegativeReasonButton from './UserRatingNegativeReasonButton.js';
import {RATING_REASON_INITIAL_LABEL} from './UserRatingNegativeReasonButton.js';
import CONFIG from '../global/libs/CONFIG.js';
import myAjax from '../global/libs/myAjax.js';
import PropTypes from 'prop-types';
import {MaterialSymbol} from 'react-material-symbols';
import 'react-material-symbols/outlined';

let UserRatingButton = createReactClass({
  propTypes: {
    result: PropTypes.object,
    question: PropTypes.string,
    logId: PropTypes.number,
    cgId: PropTypes.string,
    logUrl: PropTypes.string,
    ratingAnswerRequired: PropTypes.bool,
    enableRatingReason: PropTypes.bool,
    enableInquiry: PropTypes.bool,
    ratingReasonMsg: PropTypes.string,
    ratingReasons: PropTypes.array
  },
  getInitialState: function () {
    console.log('UserRatingButton.getInitialState');
    let btnInitial = 'btn-rating-initial btn-rating';
    let btnClicked = 'btn-rating-clicked btn-rating';
    let ratings = [
      {
        id: 'btn1',
        className: btnInitial,
        value: 1,
        icon: 'thumb_up',
        label: '役に立った'
      },
      {
        id: 'btn2',
        className: btnInitial,
        value: 2,
        icon: 'thumb_down',
        label: '役に立たなかった'
      }
    ];
    if (!this.props.ratingAnswerRequired) {
      ratings.push({
        id: 'btn3',
        className: btnInitial,
        value: 3,
        icon: 'remove',
        label: 'どちらでもない'
      });
    }
    const logId = this.props.logId;
    const logUrl =
      this.props.logUrl === undefined || this.props.logUrl.length === 0 ? '/api/logging/core/' : this.props.logUrl;

    return {
      btnInitial: btnInitial,
      btnClicked: btnClicked,
      ratings: ratings,
      userRating: -1,
      askUserRatingReason: false,
      logId: logId,
      logUrl: logUrl,
      hasRatingFinished: false
    };
  },

  onClick(userRating) {
    const ratings = this.state.ratings;
    const logUrl = this.state.logUrl;

    let askUserRatingReason = false;
    if (userRating === 2 && this.props.enableRatingReason) {
      askUserRatingReason = true;
    }
    console.log(userRating);
    console.log(askUserRatingReason);

    ratings.forEach((r) => {
      if (r.value === userRating) {
        document.getElementById(r.id).className = this.state.btnClicked;
      } else {
        document.getElementById(r.id).className = this.state.btnInitial;
      }
    });

    this.setState({hasRatingFinished: false});

    let logId = this.props.logId;

    let sendDict = {
      user_rating: userRating
    };
    if (userRating !== this.state.userRating) {
      sendDict.negative_rating_reason = RATING_REASON_INITIAL_LABEL;
      sendDict.negative_rating_reason_free = '';
    }

    myAjax(logUrl + logId, sendDict, 'PATCH').done(
      function () {
        let updateState = {
          userRating: userRating,
          askUserRatingReason: askUserRatingReason,
          hasRatingFinished: true
        };
        ratings.forEach((r) => {
          updateState[r.id] = document.getElementById(r.id).className;
        });
        console.log(updateState);
        this.setState(updateState);
      }.bind(this)
    );
  },

  openInquiryCreate() {
    const MAX_LENGTH = 1000;
    let question = this.props.question;
    let qa_id = this.props.result ? this.props.result.id : undefined;
    let user_q_id = this.props.logUrl ? 0 : this.props.logId; // QA共有の場合、ログIDは除去
    let qa_query = '';
    let cg_id = this.props.cgId;

    if (question.length > MAX_LENGTH) {
      question = question.substring(0, MAX_LENGTH);
    }
    qa_query = qa_id ? '&qa=' + qa_id : '';
    qa_query += user_q_id ? '&user_q_id=' + user_q_id : '';
    qa_query += cg_id ? '&cg_id=' + encodeURIComponent(cg_id) : '';
    const INQUIRY_CREATE_SITE = CONFIG.INQUIRY_URL + '/?question=' + encodeURIComponent(question) + qa_query;
    window.open(INQUIRY_CREATE_SITE);
  },

  componentDidUpdate() {},

  render() {
    if (this.state.logId !== this.props.logId) {
      this.setState(this.getInitialState());
    }

    const ratings = this.state.ratings;
    const ratingButtons = ratings.map((r) => (
      <button key={r.id} id={r.id} className={r.className} onClick={this.onClick.bind(this, r.value)}>
        <MaterialSymbol icon={r.icon} size={50} />
        <br />
        {r.label}
      </button>
    ));
    const enableInquiry = (this.props.enableInquiry === undefined || this.props.enableInquiry) && CONFIG.ENABLE_INQUIRY;

    const showAddtionalMessage = Boolean(!this.state.logUrl.includes('/api/logging/shareqa'));
    const userRatingThanksMsg = !this.state.askUserRatingReason ? (
      <div>
        ご協力ありがとうございました。
        {showAddtionalMessage ? (
          <>
            <br />
            <span>最初から質問する場合は、右上のホームアイコンを押してください。</span>
          </>
        ) : null}
      </div>
    ) : null;

    return (
      <div>
        <table className="tbl-layout">
          <tbody>
            <tr>
              <th className="title-layout">アンケート：回答はお役に立ちましたか？</th>
            </tr>
            <tr>
              {this.state.hasRatingFinished ? (
                <td id="user-rating-reason-message" className="user-rating-msg user-rating-msg-clicked">
                  {userRatingThanksMsg}
                </td>
              ) : (
                <td id="user-rating-reason-message" className="user-rating-msg user-rating-msg-initial"></td>
              )}
            </tr>
            <tr>
              <td>
                <div className="btn-layout">{ratingButtons}</div>
                {enableInquiry ? (
                  <div className="btn-inquiry-layout">
                    <button id="btnInquiry" className="btn-inquiry" onClick={this.openInquiryCreate}>
                      回答についてお問い合わせ・コメント
                    </button>
                  </div>
                ) : null}
              </td>
            </tr>
          </tbody>
        </table>
        {this.state.askUserRatingReason ? (
          <UserRatingNegativeReasonButton
            logUrl={this.props.logUrl}
            result={this.props.result}
            logId={this.props.logId}
            cgId={this.props.cgId}
            ratingReasonMsg={this.props.ratingReasonMsg}
            ratingReasons={this.props.ratingReasons}
          />
        ) : null}
      </div>
    );
  }
});

export default UserRatingButton;
